import React from "react";
import { isEmpty } from "lodash";
import clsx from "clsx";
// components
import RMDRImage from "@/components/RMDRImage";
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";
import LineShape02 from "@/components/shapes/LineShape02";
import LineShape03 from "@/components/shapes/LineShape03";
// utilities
import { 
    mainPageItemNameDescriptionLanguageVersion,
    outerNameDescriptionLanguageVersion
} from "@/utilities/LanguageVersionSelectorShortcut";
import LanguageVersionSelector from "@/utilities/LanguageVersionSelector";
// types
import { TMainPageLayoutV2 } from "../type";
import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";
import TLanguageVersionDetail from "@/cms/types/TLanguageVersionDetail";
import TResource from "@/cms/types/TResource";
// enums
import EResourceType from "@/cms/enums/EResourceType";
import ELayoutType from "@/cms/enums/ELayoutType";
import EContentType from "@/cms/enums/EContentType";
import EView from "@/cms/enums/EView";


type TRender = {
    languageVersion: TLanguageVersionList|TLanguageVersionDetail;
    languageVersionPage?: TLanguageVersionList|TLanguageVersionDetail;

    resources: TResource[];
    resourceType: EResourceType;

    childs?:TClientMainPageItemList[];
    _layoutType?:ELayoutType;
}

const RenderItems = ( props:TRender ) => {
    return props.childs?.map((item,index) => {
        const languageVersion = mainPageItemNameDescriptionLanguageVersion(item.languageVersions);

        return (
            <div
                className={clsx("icon-items", {"style-2":(index+1)%2===0})}
                data-aos-duration="800"
                data-aos="fade-up"
                data-aos-delay={`${300+(index*200)}`}
            >
                <div className="icon">
                    <RMDRImage 
                        resources={item?.resources}
                        resourceType={EResourceType.ICON}
                        alt={languageVersion?.name}
                        title={languageVersion?.name}
                    />
                </div>
                <div className="content">
                    <RMDRComponentSanitizer languageVersion={languageVersion} valueExpr="value" variant="p" removeTag />
                </div>
            </div>
        )
    })
}

const Render = ( props:TRender ) => {
    return (
        <section className={clsx("section fix", {"section-padding":props._layoutType}, {"section-padding-2":!props._layoutType})}>
            <LineShape02 />
            <LineShape03 />
            <div className="container">
                <div className="service-wrapper">
                    <div className="row g-4">
                        <div className="col-lg-6">
                            <div className="service-left">
                                <div className="section-title">
                                    <h2
                                        data-aos-duration="800"
                                        data-aos="fade-up"
                                        data-aos-delay="300"
                                    >
                                        {props.languageVersionPage?.name}
                                    </h2>
                                </div>
                                <RMDRComponentSanitizer 
                                    languageVersion={props.languageVersionPage} 
                                    valueExpr="value" 
                                    variant="p"
                                    className="mt-3 mt-md-0"
                                    extraData={{
                                        "data-aos-duration": "800",
                                        "data-aos": "fade-up",
                                        "data-aos-delay": "500"
                                    }}
                                    removeTag 
                                />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="service-right">
                                <RenderItems {...props} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

const RenderDetails = ( props:TMainPageLayoutV2 ) => {

    if ( !props.params?.["contentDetails"] || isEmpty(props.params?.["contentDetails"]) ) return null;

    const languageVersion = outerNameDescriptionLanguageVersion(props.params["contentDetails"].languageVersions);
    const languageVersionPage = LanguageVersionSelector<TLanguageVersionDetail|undefined>({
        languageVersions: props.params["contentDetails"].languageVersions,
        filters: [
            { view: EView.INNER, contentType: EContentType.PAGE }
        ],
        type: "find"
    });
    const childs = props.templates?.filter((item) => item.parentId === props.template?.id)

    if ( !languageVersion || isEmpty(languageVersion) ) return null;

    return <Render 
        languageVersion={languageVersion} 
        languageVersionPage={languageVersionPage}
        resources={props.params["contentDetails"].resources} 
        resourceType={EResourceType.INNER_IMAGE} 
        childs={childs}
        _layoutType={props._layoutType}
    />

}

const RenderTemplate = ( props:TMainPageLayoutV2 ) => {

    if ( !props.template || isEmpty(props.template) ) return null;

    const languageVersion = outerNameDescriptionLanguageVersion(props.template.languageVersions);
    const childs = props.templates?.filter((item) => item.parentId === props.template?.id)

    if ( !languageVersion || isEmpty(languageVersion) ) return null;

    return <Render 
        languageVersion={languageVersion}
        languageVersionPage={languageVersion}
        resources={props.template.resources} 
        resourceType={EResourceType.OUTER_IMAGE} 
        childs={childs}
        _layoutType={props._layoutType}
    />

}

const MNPG055 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG055.rendered", props); 

    if ( !props.template || isEmpty(props.template) ) return null;

    if ( props._layoutType === ELayoutType.MAIN_PAGE ) {
        return <RenderTemplate {...props} />
    }
    else {
        return <RenderDetails {...props} />
    }
}

const Component = React.memo(MNPG055, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    console.log("MNPG055.memo", { prevProps, nextProps });
    return true;
});

export default Component;
